import {colors} from '@supermove/styles';

const WORK = 'work';
const DRIVE = 'drive';
const BREAK = 'break';
const WAIT = 'wait';

const KIND_TO_DISPLAY = {
  [WORK]: 'Work',
  [DRIVE]: 'Drive',
  [BREAK]: 'Break',
  [WAIT]: 'Wait',
};

const KIND_TO_COLOR = {
  [WORK]: colors.green.status,
  [DRIVE]: colors.yellow.hover,
  [BREAK]: colors.gray.secondary,
  [WAIT]: colors.blue.accentDark,
};

const KIND_TO_BACKGROUND_COLOR = {
  [WORK]: colors.green.accent,
  [DRIVE]: colors.yellow.accent,
  [BREAK]: colors.gray.background,
  [WAIT]: colors.blue.accent,
};

const Values = [WORK, DRIVE, BREAK, WAIT];
const DropdownOptions = Values.map((kind) => ({
  value: kind,
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  label: KIND_TO_DISPLAY[kind],
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  color: KIND_TO_COLOR[kind],
}));

// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const getDisplay = (kind: any) => KIND_TO_DISPLAY[kind];
// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const getColor = (kind: any) => KIND_TO_COLOR[kind];
// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const getBackgroundColor = (kind: any) => KIND_TO_BACKGROUND_COLOR[kind];

export default {
  WORK,
  DRIVE,
  BREAK,
  WAIT,

  KIND_TO_DISPLAY,
  KIND_TO_COLOR,

  Values,
  DropdownOptions,

  getDisplay,
  getColor,
  getBackgroundColor,
};
